import { render, staticRenderFns } from "./post-select-widget.vue?vue&type=template&id=413c11ce&scoped=true&"
import script from "./post-select-widget.vue?vue&type=script&lang=js&"
export * from "./post-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./post-select-widget.vue?vue&type=style&index=0&id=413c11ce&prod&lang=scss&scoped=true&"
import style1 from "./post-select-widget.vue?vue&type=style&index=1&id=413c11ce&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c11ce",
  null
  
)

export default component.exports